import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import type {
  LeagueTrckVaultGatedHowItWorksDialogQuery,
  LeagueTrckVaultGatedHowItWorksDialogQueryVariables,
} from './__generated__/index.withFetch.graphql.ts';
import { LeagueTrckVaultGatedHowItWorksDialog } from './index.tsx';

const query = gql`
  query LeagueTrckVaultGatedHowItWorksDialogQuery(
    $sport: Sport!
    $leaderboardSlug: String!
  ) {
    config {
      id
      sealingConfig(sport: $sport) {
        ...LeagueTrckVaultGatedHowItWorksDialog_sealingConfig
      }
    }
    so5 {
      so5Leaderboard(slug: $leaderboardSlug) {
        slug
        ...LeagueTrckVaultGatedHowItWorksDialog_so5Leaderboard
      }
    }
  }
  ${LeagueTrckVaultGatedHowItWorksDialog.fragments.sealingConfig}
  ${LeagueTrckVaultGatedHowItWorksDialog.fragments.so5Leaderboard}
` as TypedDocumentNode<
  LeagueTrckVaultGatedHowItWorksDialogQuery,
  LeagueTrckVaultGatedHowItWorksDialogQueryVariables
>;

type Props = {
  open?: boolean;
  onClose: () => void;
  rarity?: Rarity;
  leaderboardSlug?: string;
};

export const LeagueTrckVaultGatedHowItWorksDialogWithFetch = ({
  open = false,
  onClose,
  rarity = Rarity.limited,
  leaderboardSlug = '',
}: Props) => {
  const { sport } = useSportContext();

  const { data, loading } = useQuery(query, {
    skip: !open,
    variables: {
      sport,
      leaderboardSlug,
    },
  });

  const sealingConfig = data?.config?.sealingConfig;
  const so5Leaderboard = data?.so5?.so5Leaderboard;

  return (
    <LeagueTrckVaultGatedHowItWorksDialog
      open={Boolean(open && data)}
      loading={loading}
      onClose={onClose}
      sealingConfig={sealingConfig}
      rarity={rarity}
      so5Leaderboard={so5Leaderboard}
    />
  );
};
